









































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  DataFilterModel,
  InteractionModel,
  TicketModel,
} from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
@Component
export default class CardContractComponent extends Vue {
  @Prop(Object) readonly data!: DataFilterModel;

  private get refs() {
    return refsService;
  }
  private get document() {
    return this.refs.util.createMask(
      this.data.CustomerDocument,
      this.data.CustomerDocument.length == 11
        ? '###.###.###-##'
        : '##-###-###/####-##'
    );
  }

  private createTicket(data: DataFilterModel) {
    const ticket = new TicketModel();

    if (this.refs.enumHelper.dataOriginIsBilling(data)) {
      ticket.Subject = this.$t('tracker.contract_changes').toString();
      ticket.ContractId = data.Id;
    } else if (this.refs.enumHelper.dataOriginIsInsurance(data)) {
      ticket.Subject = this.$t('tracker.insurance_changes').toString();
      ticket.PolicyId = data.Id;
    }

    this.refs.modules.company.account.Id = data.TenantId;

    this.refs.modules.ticket
      .createTicket(ticket)
      .then((res) => {
        this.refs.modules.ticket.ticket.Id = res.Id;
        this.refs.modules.ticket.SET_CONSULT_RESET(false);
        this.refs.modules.ticket.createInteraction(
          new InteractionModel(
            this.$t('action_code.ac0'),
            this.$t('action_desc.ad0')
          )
        );
        this.$router.push({
          name: 'contracts-dataorigin-tenantid-number-id',
          params: {
            dataorigin: this.refs.enums.DataOrigin[data.DataOrigin],
            tenantid: data.TenantId,
            id: data.Id,
            number: data.Number,
          },
        });
      })
      .catch(() => this.$toast(this.$t('toasts.unable_start_service')));
  }
}
